import { EntityTypeEnum } from "../../enums/entity-type-id-enum";
import { BaseModel } from "../base.model";

export class ContactBaseModel extends BaseModel{
    number: string ="";
    firstName: string ="";
    lastName: string ="";
    fullName: string = "";
    email: string ="";
    phoneNumber: string ="";
    faxNumber: string ="";
    companyName: string ="";
    enabled: boolean = true;
    profilePhotoFileId?: string;
    listPhoto?: any;
}
